import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostDeactivateGeofencePayload, PostDeactivateGeofenceResponse } from '@/api/geofence/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postDeactivateGeofence = (
    payload: PostDeactivateGeofencePayload
): Promise<PostDeactivateGeofenceResponse> => {
    return axios.post('/device/deactivate-geofence', payload);
};

type UsePostDeactivateGeofenceOptions = {
    config?: MutationConfig<typeof postDeactivateGeofence>;
    data?: PostDeactivateGeofencePayload;
};

export const usePostDeactivateGeofence = ({ config }: UsePostDeactivateGeofenceOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postDeactivateGeofence,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Geofence deactivated', {
                spotterId: variables.spotterId,
            });
        },
        onError: createErrorHandler('deactivate geofence'),
    });
};
